<template>
  <!-- Display a payment form -->
  <div>
    <hr class="mt-3 mb-3">

    <div class="poweredBy">
      <span class="small">Powered by
        <svg
          class=""
          focusable="false"
          width="33"
          height="15"
        ><g fill-rule="evenodd"><path d="M32.956 7.925c0-2.313-1.12-4.138-3.261-4.138-2.15 0-3.451 1.825-3.451 4.12 0 2.719 1.535 4.092 3.74 4.092 1.075 0 1.888-.244 2.502-.587V9.605c-.614.307-1.319.497-2.213.497-.876 0-1.653-.307-1.753-1.373h4.418c0-.118.018-.588.018-.804zm-4.463-.859c0-1.02.624-1.445 1.193-1.445.55 0 1.138.424 1.138 1.445h-2.33zM22.756 3.787c-.885 0-1.454.415-1.77.704l-.118-.56H18.88v10.535l2.259-.48.009-2.556c.325.235.804.57 1.6.57 1.616 0 3.089-1.302 3.089-4.166-.01-2.62-1.5-4.047-3.08-4.047zm-.542 6.225c-.533 0-.85-.19-1.066-.425l-.009-3.352c.235-.262.56-.443 1.075-.443.822 0 1.391.922 1.391 2.105 0 1.211-.56 2.115-1.39 2.115zM18.04 2.766V.932l-2.268.479v1.843zM15.772 3.94h2.268v7.905h-2.268zM13.342 4.609l-.144-.669h-1.952v7.906h2.259V6.488c.533-.696 1.436-.57 1.716-.47V3.94c-.289-.108-1.346-.307-1.879.669zM8.825 1.98l-2.205.47-.009 7.236c0 1.337 1.003 2.322 2.34 2.322.741 0 1.283-.135 1.581-.298V9.876c-.289.117-1.716.533-1.716-.804V5.865h1.716V3.94H8.816l.009-1.96zM2.718 6.235c0-.352.289-.488.767-.488.687 0 1.554.208 2.241.578V4.202a5.958 5.958 0 0 0-2.24-.415c-1.835 0-3.054.957-3.054 2.557 0 2.493 3.433 2.096 3.433 3.17 0 .416-.361.552-.867.552-.75 0-1.708-.307-2.467-.723v2.15c.84.362 1.69.515 2.467.515 1.879 0 3.17-.93 3.17-2.548-.008-2.692-3.45-2.213-3.45-3.225z" /></g></svg></span></a>
    </div>

    <form
      id="payment-form"
    >
      <div ref="stripeCheckout" />
      <div id="payment-element">
      <!--Stripe.js injects the Payment Element-->
      </div>

      <div
        id="payment-message"
        class="hidden"
      />

      <button
        id="submit"
        class="mb-2"
      >
        <div
          id="spinner"
          class="spinner hidden"
        />
        <span id="button-text">{{ this.$t('lang.bookings.payment') }}</span>
      </button>
      <b-link
        class="d-block mx-auto text-center mb-3"
        @click="validatePayment"
      >
        {{ $t('lang.bookings.validate_pix_payment') }}
      </b-link>
    </form>
  </div>
</template>
<script>
export default {
  name: 'StripeCheckout',
  props: {
    returnUrl: {
      type: String,
      required: true,
    },
    paymentPreferenceId: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  async mounted() {
    const stripeScript = document.createElement('script');
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');

    this.$refs.stripeCheckout.appendChild(stripeScript);

    const context = this;
    stripeScript.onload = function () {
      const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY, {
        locale: context.$store.state.main.lang,
      });

      const elements = stripe.elements({
        clientSecret: context.paymentPreferenceId,
        appearance: {
          theme: 'flat',
        },
      });

      const paymentElement = elements.create('payment', {
        defaultValues: {
          billingDetails: {
            name: context.booking.user.full_name,
            email: context.booking.user.email,
          },
        },
      });
      paymentElement.mount('#payment-element');

      // this is the handleSubmit function
      document.querySelector('#payment-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        context.setLoading(true);
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: context.returnUrl,
          },
        });
        if (error.type === 'card_error' || error.type === 'validation_error') {
          context.showMessage(error.message);
        } else {
          context.showMessage('An unexpected error occured.');
        }

        context.setLoading(false);
      });
    };

    this.checkErrors();
  },

  methods: {
    // ------- UI helpers -------

    showMessage(messageText) {
      const messageContainer = document.querySelector('#payment-message');

      messageContainer.classList.remove('hidden');
      messageContainer.textContent = messageText;

      setTimeout(() => {
        messageContainer.classList.add('hidden');
        messageText.textContent = '';
      }, 4000);
    },

    // Show a spinner on payment submission
    setLoading(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector('#submit').disabled = true;
        document.querySelector('#spinner').classList.remove('hidden');
        document.querySelector('#button-text').classList.add('hidden');
      } else {
        document.querySelector('#submit').disabled = false;
        document.querySelector('#spinner').classList.add('hidden');
        document.querySelector('#button-text').classList.remove('hidden');
      }
    },

    checkErrors() {
      // If the element isn't loaded in 5 seconds, shows an alert.
      setTimeout(() => {
        const button = document.getElementsByClassName('__PrivateStripeElement');
        if (button === undefined || button.length === 0) {
          this.$emit('paymentError');
        }
      }, 5000);
    },

    validatePayment() {
      const validatePaymentUrl = `/process_payment/stripe?booking_id=${this.booking.id}&payment_intent=${this.paymentPreferenceId.split('_secret_')[0]}`;
      this.$router.push(validatePaymentUrl);
    },
  },
};
</script>

<style scoped>
/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

form {
  width: 100% !important;
  /*min-width: 500px;*/
  align-self: center;
  /*box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),*/
  /*0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);*/
  border-radius: 7px;
  padding: 0px 10px 10px 10px;
}
@media (max-width: 768px) {
  form {
    padding: 0;
  }
}

.hidden {
  display: none;
}

#payment-message {
  color: #df1b41; /* same as stripe errors text-color */
  font-size: 16px;
  line-height: 20px;
  padding: 12px 0;
  text-align: left;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button {
  background: #ff1460;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #ff1460;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #ff1460;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
    min-width: initial;
  }
}

.poweredBy{
  text-align: right;
}
</style>
